export const ProfileRoutes = {
  updateUser: '/profile/userInfo/update/:userId',
  userInfo: '/profile/userInfo/:userId', // get
  notifyAPIRequest: '/profile/notify-api/:userId',
  couponContract: '/profile/coupon-contract', // * post
  updateCoupon: '/profile/coupons/:couponId', // * put
  addCoupon: '/profile/coupons/assign/:code',
  deleteTemplate: '/profile/template/delete/:id',
  addTemplate: '/profile/template/new',
  chargeContract: '/profile/payment/new',
  forceDelete: '/profile/user/delete/:id',
  removeAdmin: '/profile/admins/delete',
  removeSigner: '/profile/signers/delete',
  removeCard: '/profile/cards/delete',
  adminQueue: '/profile/queue-admin',
  signerQueue: '/profile/queue-signer',
  addPayment: '/profile/payment/add',
  addEmail: '/profile/email/add',
  addAdmin: '/profile/admins/add',
  signUser: '/profile/user/sign/:id', // * post
  addSignerToProfile: '/profile/signers/add', // addSigner
  coupons: '/profile/coupons/:userId',
  templates: '/profile/templates/:userId',
  payments: '/profile/payments/:userId',
  getLastSigners: '/profile/last-signers/:userId',
  admins: '/profile/admins/:userId',
  signers: '/profile/signers/:userId',
  getUserProfile: '/profile/user/:id',
  addProfileImage: '/profile/image/add',
  updateSigner: '/profile/update-signer',
  updateNotifications: '/profile/update-notifications',
  downloadContractToViewProfile: '/profile/downloadContractToViewProfile/:id',
  registerUsersToDownloadContracts: '/profile/registerAuthorizedUsers',
  getMyUsers: '/profile/getMyUsers/:id',
  createContractToAuthorizeDownload:
    '/profile/createContractToAuthorizeDownload',
  sendResponseToAuthorize: 'profile/sendResponseToAuthorize',
  updateUserData: '/profile/update-user-data/:userId',
};
